import type { CSSProperties } from 'react';
import type { HoverInfo } from '../scene/Cuboids';

const RAD_TO_DEG = 180 / Math.PI;

/** Cursor-following tooltip with the hovered cuboid's details. */
export function CuboidTooltip({ info }: { info: HoverInfo }) {
  const { cuboid, x, y } = info;
  const [w, l, h] = cuboid.dimensions;
  const [px, py, pz] = cuboid.position;

  const style: CSSProperties = {
    position: 'fixed',
    left: x + 14,
    top: y + 14,
    padding: '8px 11px',
    borderRadius: 6,
    background: 'rgba(12,16,22,0.92)',
    color: '#e6edf3',
    font: '12px/1.55 system-ui, sans-serif',
    border: '1px solid rgba(255,255,255,0.12)',
    pointerEvents: 'none', // never let the tooltip eat pointer events
    zIndex: 10,
    maxWidth: 260,
  };

  return (
    <div style={style}>
      <div style={{ fontWeight: 600, color: '#ffcf33', marginBottom: 2 }}>{cuboid.label}</div>
      <Row k="dims (W×L×H)" v={`${w.toFixed(2)} × ${l.toFixed(2)} × ${h.toFixed(2)} m`} />
      <Row k="position" v={`${px.toFixed(1)}, ${py.toFixed(1)}, ${pz.toFixed(1)}`} />
      <Row k="yaw" v={`${(cuboid.yaw * RAD_TO_DEG).toFixed(1)}°`} />
      <Row k="state" v={cuboid.stationary ? 'stationary' : 'moving'} />
    </div>
  );
}

function Row({ k, v }: { k: string; v: string }) {
  return (
    <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between' }}>
      <span style={{ opacity: 0.6 }}>{k}</span>
      <span>{v}</span>
    </div>
  );
}
